import React, { useEffect, useState } from 'react'
import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'
import { number, bool, func, object } from 'prop-types'
import { Obras, Postagens } from '../../../services/http'
import CleanModal from '../../../components/shared/modals/CleanModal'
import { styled } from '@mui/material'
import Dater from '../../../services/DateFormat'
import gerarPaginacao from '../../../services/pagination'
import HelpIcon from '@mui/icons-material/Help'
import BaseTooltip from '../../../components/BaseTooltip'

const StyledBD = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '38vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '38vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '51vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'justify',
    '&:nth-of-type(2)': {
      marginLeft: '0.3rem'
    }
  }
}))

const ModalDiv = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    overflowY: 'scroll'
  },
  [theme.breakpoints.up('md')]: {
    overflowY: 'hidden'
  }
}))

const DashBoardModal = ({ onClose, open, obraId = null, filters }) => {
  const [tloading, setTloading] = useState(false)
  useEffect(() => {
    if (obraId !== null) {
      getObraById(obraId, {
        'includes[postagens][ano_id]': filters.ano_id,
        'includes[postagens][mes_id]': filters.mes_id
      })
    }
  }, [obraId, filters])

  async function getObraById(id) {
    setTloading(true)

    try {
      const { data } = await Postagens().show({
        obra_id: id,
        'includes[]': 'leitor.user,leitor.biblioteca',
        ano_id: filters.ano_id || new Date().getFullYear(),
        mes_id: filters.mes_id,
        per_page: -1
      })
      mountDashboardModalData(data.data)
    } catch (e) {
      console.log(e)
    } finally {
      setTloading(false)
    }
  }
  const [rows, setRows] = useState([])

  const mountDashboardModalData = postagens => {
    const aux = postagens.map(item => {
      return {
        ...item,
        colaborador: item.leitor.user.name,
        dataPost: Dater().formatar(item.created_at, 'dd/mm/yyyy, hours:mins'),
        periodo: item.mes_id + '/' + item.ano_id,
        biblioteca: item.leitor.biblioteca.apelido
      }
    })

    setRows(aux)
    setTloading(false)
  }

  const columns = [
    {
      field: 'colaborador',
      headerName: 'Leitor',
      flex: 2,
      align: 'left'
    },
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 1,
      align: 'center'
    },
    {
      field: 'periodo',
      headerName: 'Período',
      flex: 1,
      align: 'left'
    },
    {
      field: 'dataPost',
      headerName: (
        <div className="d-flex align-center">
          Data da postagem
          <BaseTooltip
            title="hora referente ao horário de Brasília"
            followCursor
          >
            <HelpIcon />
          </BaseTooltip>
        </div>
      ),
      flex: 1.5,
      align: 'left'
    }
  ].map(item => ({
    ...item,
    headerClassName: 'styledHeader',
    sortable: false
  }))

  const [status, setStatus] = useState(false)

  React.useEffect(() => {
    setStatus(open)
  }, [open])

  React.useEffect(() => {
    onClose(status)
  }, [status])

  const pagination = gerarPaginacao(true, 1, 1, () => {}, 2)

  return (
    <CleanModal
      title="Histórico de Postagens"
      sx={{ width: { xs: '100vw', md: '60vw' } }}
      status={status}
      onClose={() => onClose(false)}
    >
      <>
        <ModalDiv
          style={{
            maxHeight: '70vh'
          }}
        >
          <StyledBD
            sx={{ border: 'none' }}
            rows={rows}
            columns={columns}
            pagination={pagination}
            pageSize={15}
            rowsPerPageOptions={[15]}
            disableColumnMenu
            disableSelectionOnClick
            loading={tloading}
          />
        </ModalDiv>
      </>
    </CleanModal>
  )
}
DashBoardModal.propTypes = {
  obraId: number,
  open: bool,
  onClose: func,
  filters: object
}
export default DashBoardModal
